import * as React from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import styled from 'styled-components';
import { Translate } from 'react-localize-redux';

import { AnimatePresence } from 'framer-motion';

import AppState from '@webapp/store/state';

import { ForgotPasswordStart } from '@webapp/store/auth/action-creators';
import { FORGOT_PASSWORD_START } from '@webapp/store/auth/actions';

import Box from '@components/layout/box';
import BoxHeader from '@components/layout/box-header';
import SnackbarStatus from '@components/basics/snackbar/snackbar-status';
import { SnackbarContainer } from '@components/basics/snackbar/snackbar-container';
import { getAuthAttributes } from '@webapp/utils/auth/get-auth-attributes';

import ButtonLoading from '@webapp/controllers/button-loading';

interface SecurityPasswordCtrlProps {
  className?: string;
  success: boolean;
  isLoading: boolean;
  username: string;
  forgotPassword: (username: string) => ForgotPasswordStart;
}

const mapStateToProps = (state: AppState) => {
  const source = getAuthAttributes(state.auth.user);
  return {
    username:
      source?.email ||
      source?.telephone ||
      state.user.profile?.email ||
      state.user.profile?.telephone,
    success: !!state.auth.changePasswordSuccess,
    isLoading: !!state.ui.loading[FORGOT_PASSWORD_START],
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  forgotPassword: (username: string) =>
    dispatch(new ForgotPasswordStart(username)),
});

export const SecurityPasswordCtrl: React.FC<SecurityPasswordCtrlProps> = (
  props
) => {
  const [showNotification, setShowNotification] = React.useState(false);

  const handleSubmit = () => {
    props.forgotPassword(props.username);
    setShowNotification(true);
  };

  React.useEffect(() => {
    if (showNotification) {
      const timer = setTimeout(() => {
        setShowNotification(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showNotification]);

  return (
    <>
      <Box className={props.className} noBorderBottom>
        <BoxHeader
          title={<Translate id="USER_PROFILE.SECURITY.PASSWORD.TITLE" />}
          text={<Translate id="USER_PROFILE.SECURITY.PASSWORD.TEXT" />}
        />
        <ButtonLoading
          fullWidth
          buttonType="secondary-dark"
          isLoading={props.isLoading}
          onClick={() => handleSubmit()}
        >
          {props.isLoading ? (
            <Translate id="USER_PROFILE.SECURITY.PASSWORD.BUTTON.SENDING_EMAIL" />
          ) : (
            <Translate id="USER_PROFILE.SECURITY.PASSWORD.BUTTON.CHANGE" />
          )}
        </ButtonLoading>
      </Box>
      <AnimatePresence>
        {showNotification && props.success ? (
          <SnackbarContainer>
            <SnackbarStatus
              status="success"
              title={
                <Translate id="USER_PROFILE.SECURITY.PASSWORD.SNACKBAR.SENT" />
              }
              onClose={() => setShowNotification(false)}
            />
          </SnackbarContainer>
        ) : null}
      </AnimatePresence>
    </>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(SecurityPasswordCtrl)``);
